(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["hph-floating-launcher"] && !Shopify.designMode) return;
  try {
    (function () {
  var fab = document.getElementById('hph-fab');
  if (!fab) return;
  var toggle = document.getElementById('hph-fab-toggle');
  var actions = Array.prototype.slice.call(fab.querySelectorAll('.hph-fab__action'));

  function setOpen(open, focusFirst) {
    fab.setAttribute('data-open', open ? 'true' : 'false');
    toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
    actions.forEach(function (a) { a.setAttribute('tabindex', open ? '0' : '-1'); });
    if (open && focusFirst && actions[0]) {
      window.setTimeout(function () { actions[0].focus(); }, 60);
    }
  }

  function isOpen() { return fab.getAttribute('data-open') === 'true'; }

  toggle.addEventListener('click', function (e) {
    e.stopPropagation();
    // e.detail === 0 means the click came from the keyboard (Enter/Space): only
    // then move focus into the menu. A mouse click leaves focus on the toggle,
    // so no focus ring flashes on the first action.
    setOpen(!isOpen(), e.detail === 0);
  });

  document.addEventListener('click', function (e) {
    if (isOpen() && !fab.contains(e.target)) setOpen(false);
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && isOpen()) {
      setOpen(false);
      toggle.focus();
    }
  });

  actions.forEach(function (a) {
    a.addEventListener('click', function () { setOpen(false); });
  });
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["hph-rx-modal"] && !Shopify.designMode) return;
  try {
    (function () {
  var modal = document.getElementById('hph-rxm');
  if (!modal) return;

  var card = modal.querySelector('.hph-rxm__card');
  var lastFocus = null;

  function onKey(e) {
    if (e.key === 'Escape') { close(); return; }
    if (e.key === 'Tab') {
      var f = card.querySelectorAll('button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])');
      var vis = Array.prototype.filter.call(f, function (el) { return el.offsetParent !== null; });
      if (!vis.length) return;
      var first = vis[0], last = vis[vis.length - 1];
      if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
    }
  }

  function open() {
    lastFocus = document.activeElement;
    modal.setAttribute('data-state', 'open');
    modal.setAttribute('aria-hidden', 'false');
    window.setTimeout(function () { if (card) { card.setAttribute('tabindex', '-1'); card.focus(); } }, 80);
    document.addEventListener('keydown', onKey);
  }

  function close() {
    modal.setAttribute('data-state', 'hidden');
    modal.setAttribute('aria-hidden', 'true');
    document.removeEventListener('keydown', onKey);
    if (lastFocus && lastFocus.focus) lastFocus.focus();
  }

  modal.querySelectorAll('[data-hph-rx-close]').forEach(function (c) { c.addEventListener('click', close); });

  document.addEventListener('click', function (e) {
    var t = e.target.closest ? e.target.closest('[data-hph-rx-open]') : null;
    if (t) { e.preventDefault(); open(); }
  });
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["hph-welcome-popup"] && !Shopify.designMode) return;
  try {
    (function () {
  var pop = document.getElementById('hph-pop');
  if (!pop) return;

  var STORAGE_KEY = 'hph_welcome_popup';
  var SUB_KEY = 'hph_news_subscribed';
  var DELAY_MS = 10000;
  var TTL_DAYS = 30;

  var card = pop.querySelector('.hph-pop__card');
  var formView = pop.querySelector('.hph-pop__form-view');
  var successView = pop.querySelector('.hph-pop__success-view');
  var form = pop.querySelector('#hph-pop-form');
  var submit = pop.querySelector('.hph-pop__submit');
  var errorEl = pop.querySelector('.hph-pop__error');
  var closers = pop.querySelectorAll('[data-hph-pop-close]');
  var lastFocus = null;
  var shown = false;

  function seen() {
    try {
      var raw = window.localStorage.getItem(STORAGE_KEY);
      if (!raw) return false;
      return (Date.now() - parseInt(raw, 10)) < TTL_DAYS * 86400000;
    } catch (e) { return false; }
  }
  function mark() {
    try { window.localStorage.setItem(STORAGE_KEY, String(Date.now())); } catch (e) {}
  }
  function subscribed() {
    try { return window.localStorage.getItem(SUB_KEY) === '1'; } catch (e) { return false; }
  }
  function markSubscribed() {
    try { window.localStorage.setItem(SUB_KEY, '1'); } catch (e) {}
  }
  // Hide the "10% off" re-entry points (header pill + drawer row) on this device
  // once subscribed. For the drawer item, hide its <li> so no empty gap remains.
  function hideOffers() {
    var els = document.querySelectorAll('[data-hph-offer]');
    Array.prototype.forEach.call(els, function (el) {
      var li = el.closest ? el.closest('.hph-drawer__item') : null;
      (li || el).style.display = 'none';
    });
  }

  function open() {
    if (shown || seen() || subscribed()) return;
    shown = true;
    lastFocus = document.activeElement;
    pop.setAttribute('data-state', 'open');
    pop.setAttribute('aria-hidden', 'false');
    mark();
    // Move focus into the dialog (accessibility) but NOT onto the email input:
    // auto-focusing the field flashed a blue focus ring on open and popped the
    // mobile keyboard over the popup. The field highlights only when the user
    // clicks into it.
    window.setTimeout(function () { if (card) { card.setAttribute('tabindex', '-1'); card.focus(); } }, 80);
    document.addEventListener('keydown', onKey);
  }

  function close() {
    pop.setAttribute('data-state', 'hidden');
    pop.setAttribute('aria-hidden', 'true');
    document.removeEventListener('keydown', onKey);
    if (lastFocus && lastFocus.focus) lastFocus.focus();
  }

  function onKey(e) {
    if (e.key === 'Escape') { close(); return; }
    if (e.key === 'Tab') {
      var f = card.querySelectorAll('button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])');
      var vis = Array.prototype.filter.call(f, function (el) { return el.offsetParent !== null; });
      if (!vis.length) return;
      var first = vis[0], last = vis[vis.length - 1];
      if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
    }
  }

  closers.forEach(function (c) { c.addEventListener('click', close); });

  // Manual open from the "10% off" re-entry points. Ignores the 10s delay and the
  // 30-day seen rule (the visitor explicitly asked for the offer) and does NOT mark
  // "seen" (so the automatic popup logic is untouched). Closes the mobile drawer
  // first when the trigger lives inside it.
  function openManual() {
    var drawer = document.getElementById('hph-mobile-drawer');
    if (drawer && drawer.getAttribute('aria-hidden') === 'false') {
      drawer.setAttribute('aria-hidden', 'true');
      document.body.style.overflow = '';
      var toggles = document.querySelectorAll('[data-hph-drawer-toggle]');
      Array.prototype.forEach.call(toggles, function (t) { t.setAttribute('aria-expanded', 'false'); });
    }
    if (formView) formView.hidden = false;
    if (successView) successView.hidden = true;
    shown = true;
    lastFocus = document.activeElement;
    pop.setAttribute('data-state', 'open');
    pop.setAttribute('aria-hidden', 'false');
    window.setTimeout(function () { if (card) { card.setAttribute('tabindex', '-1'); card.focus(); } }, 80);
    document.addEventListener('keydown', onKey);
  }
  document.addEventListener('click', function (e) {
    var t = e.target.closest ? e.target.closest('[data-hph-pop-open]') : null;
    if (t) { e.preventDefault(); openManual(); }
  });
  // If the visitor already subscribed on this device, remove the re-entry points.
  if (subscribed()) hideOffers();

  if (form) {
    form.addEventListener('submit', function () {
      // Let the NATIVE submit proceed: Shopify's invisible CAPTCHA token is only
      // injected on a real submit, and a fetch submit returns 400 "Missing
      // CAPTCHA token". We tag the source + mark the popup seen; the page
      // reloads with ?customer_posted=true and we reopen in success mode below.
      if (submit) submit.setAttribute('aria-busy', 'true');
      try { sessionStorage.setItem('hph_news_src', 'popup'); } catch (e) {}
      mark();
    });
  }

  // After a successful subscribe via the popup, reopen it in success mode.
  if (/[?&](customer|contact)_posted=true/.test(window.location.search)) {
    var subSrc = null;
    try { subSrc = sessionStorage.getItem('hph_news_src'); } catch (e) {}
    if (subSrc === 'popup') {
      try { sessionStorage.removeItem('hph_news_src'); } catch (e) {}
      markSubscribed();
      hideOffers();
      if (formView) formView.hidden = true;
      if (successView) successView.hidden = false;
      shown = true;
      pop.setAttribute('data-state', 'open');
      pop.setAttribute('aria-hidden', 'false');
      document.addEventListener('keydown', onKey);
      if (card) { card.setAttribute('tabindex', '-1'); card.focus(); }
      return;
    }
  }

  if (seen()) return;

  window.setTimeout(open, DELAY_MS);
  document.addEventListener('mouseout', function (e) {
    if (!e.relatedTarget && e.clientY <= 0) open();
  });
})();
  } catch(e) { console.error(e); }
})();

})();
